import React from "react";

const Top = () => {
  return (
    <div className="start__top" data-test="top">
      <div className="start__top__image" />
      User
    </div>
  );
};

export default Top;
